import isEqual from "lodash/fp/isEqual";

class Controller {
  constructor($mdDialog, $injector, $stateParams, loan) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.$injector = $injector;
    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.Loan = $injector.get("Loan");
    this.loan = loan;

    this.isEditable = true;
    this.isMobileReturned = false;
  }

  $onInit() {
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.isMobile = this.loan.type.value === "Mobile";

    this.checkAmount();
  }

  checkAmount() {
    const remainingAmount = this.loan.remaining_amount.value;
    const totalAmount = this.loan.total_amount.value;

    if (this.isMobile) {
      if (isEqual(remainingAmount, totalAmount)) {
        this.amount = this.loan.remaining_amount.value;
      } else {
        this.amount =
          this.loan.total_amount.value - this.loan.remaining_amount.value;
      }
    } else {
      this.amount = this.loan.remaining_amount.value;
    }
  }

  toggleAmount() {
    this.isEditable = !this.isEditable;
  }

  toggleMobileProperty() {
    this.toggleAmount();

    if (this.isMobileReturned) {
      this.amount =
        this.loan.total_amount.value - this.loan.remaining_amount.value;
    } else {
      this.amount = this.loan.remaining_amount.value;
    }
  }

  confirm() {
    const isReturned = this.isMobile
      ? { is_returned: this.isMobileReturned || false }
      : {};
    const item = {
      amount: this.amount,
      note: this.note,
      ...isReturned,
    };

    this.isDisabled = true;
    this.Loan.finalize(this.$stateParams.id, item).$promise.then(
      () => {
        this.$mdDialog.hide();
        this.Events.emit(this.showNotificationEvent, {
          message: "Loan finalized successfully",
        });
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  close() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/loan/loanDialog/loanDialog.controller.js